import React from "react";
import { Link } from "react-router-dom";

export default function FeatureSection() {
  return (
    <>
      <div className="feature-about-bg">
        <section className="feature-section-three py-120 rpt-100">
          <div className="container-fluid clearfix px-70">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="section-title mb-55">
                  <h2><span className="text-green">Shaping the Digital Tomorrow:</span> Welcome to Next Cosmos Technology</h2>
                  <h3>Empowering the Digital Future</h3>
                  <span className="sub-title">
                    Pioneering the Future of Technology: Since our founding in
                    2022, Next Cosmos Technology has become a leading force in
                    the IT industry. Driven by a team of visionaries, we ' re
                    reshaping technology ' s limits, accelerating businesses
                    into the digital future with unparalleled innovation and
                    agility.
                  </span>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="feature-item-three wow fadeInUp delay-0-2s element">
                  <div className="icon">
                    <img
                      src={require(`../../assets/images/feature/icon1.png`)}
                      alt="Icon"
                    />
                  </div>
                  <div className="feature-content">
                    <h4>
                      <Link to="/about">
                        Our Mission: Redefining Possibilities
                      </Link>
                    </h4>
                    <p>
                      Our commitment to excellence and innovation has set new
                      industry standards, establishing us as a global leader in
                      IT solutions. Through a blend of pioneering technologies
                      and strategic insights, we empower our clients to not just
                      navigate but thrive in the digital landscape.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="feature-item-three wow fadeInUp delay-0-4s element">
                  <div className="icon">
                    <img
                      src={require(`../../assets/images/feature/icon2.png`)}
                      alt="Icon"
                    />
                  </div>
                  <div className="feature-content">
                    <h4>
                      <Link to="/about">
                        A Legacy of Innovation and Integrity
                      </Link>
                    </h4>
                    <p>
                      Our success is powered by a diverse team of experts,
                      bonded by a passion for excellence and innovation. Our
                      culture promotes creativity and the pursuit of
                      transformative solutions, with integrity and excellence at
                      the core of everything we do, ensuring we provide our
                      partners and clients with valuable, trustworthy solutions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-md-6">
                <div className="feature-item-three no-border wow fadeInUp delay-0-6s">
                  <div className="icon">
                    <img
                      src={require(`../../assets/images/feature/icon3.png`)}
                      alt="Icon"
                    />
                  </div>
                  <div className="feature-content">
                    <h4>
                      <Link to="/about">
                        Your Partners in Digital Transformation
                      </Link>
                    </h4>
                    <p>
                      As architects of the digital future, our vision is clear -
                      to be the catalyst for transformative change. We provide
                      cutting-edge IT solutions that drive growth, foster
                      innovation, and redefine what' s possible, ensuring
                      businesses are not just participants but leaders in the
                      digital era.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
